// helpers/notificationHistory.js

import axios from "axios";

export const fetchNotificationHistory = async (params = {}) => {
  try {

    const response = await axios.get(
      "/api/notifications",
      {
        params,
        withCredentials: true,
      }
    );

    const data = response?.data;

    return Array.isArray(data?.notifications)
      ? data.notifications
      : [];

  } catch {
    return [];
  }
};